import AnimarAlScroll from "../Animaciones/AnimarAlScroll";
import "./Filosofia.css";

function Filosofia() {
  return (
    <section className="filosofia" id="filosofia">
      <AnimarAlScroll>
      <div className="contenedor">
        <div className="filosofia-contenido">
          <span className="filosofia-eyebrow">Nuestra filosofía</span>
          <div className="linea-decorativa"></div>

          <p className="filosofia-parrafo">
            En GlowRoom creemos que verte increíble cambia cómo te sentís.
          </p>

          <p className="filosofia-parrafo">
            No se trata solo de uñas, pestañas o cejas: se trata de actitud,
            seguridad y de ese momento en el que te mirás al espejo y decís
            "sí, era esto".
          </p>

          <p className="filosofia-parrafo">
            Nuestra filosofía es potenciar tu versión más segura, femenina y
            poderosa, cuidando cada detalle y manteniendo siempre tu esencia.
          </p>

          <p className="filosofia-texto filosofia-mantra">
            GlowRoom es belleza con actitud.
            <br />
            Es detalle. Es confianza. Es <em>sentirte esa</em>.
          </p>
        </div>
      </div>
      </AnimarAlScroll>
    </section>
  );
}

export default Filosofia;
